module.exports = __webpack_public_path__ + "img/3Dian5_3.bae67af6.png";